import classNames from "classnames";
import { FunctionComponent } from "react";

interface LogoProps extends React.DetailedHTMLProps<React.AnchorHTMLAttributes<HTMLAnchorElement>, HTMLAnchorElement> {}

const Logo: FunctionComponent<LogoProps> = ({ className, ...anchorProps }) => {
  return (
    <a href="/" className={classNames(className, "text-xl font-bold")} {...anchorProps}>
      Configurio
    </a>
  );
};

export default Logo;
